import {Box, Typography, Card, Grid, CardContent, Link, Stack} from "@mui/material";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Page from "src/components/Page";
import useLocales from "src/hooks/useLocales";
import { PATH_DASHBOARD } from "src/routes/paths";
import { useEffect } from "react";
import Logo from "../../../../../components/Logo";
import {DOMAIN_NAME} from "../../../../../config";

const Message = ({ mdDown }) => {
    const { translate } = useLocales();
    return (
        <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
            <Box sx={{
                flexGrow: 1,
                ...(mdDown && {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column'
                })
            }}>
                {mdDown ? (
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mb: 3 }}>
                        <Logo style={{ width: 200, maxWidth: '100%', height: 'auto' }} />
                    </Box>
                ) : null}
                <Typography variant="h4" gutterBottom>
                    {translate("auth.login.signInTo", { domain: DOMAIN_NAME })}
                </Typography>
            </Box>
        </Stack>
    );
};

export default Message;
